import styled from "styled-components/macro";
export interface ImageWrapperProps {
  background: string;
}

export const StyledFooter = styled.footer`
  background: #fbfbfb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 3rem;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledImageWrapper = styled.div<ImageWrapperProps>`
  height: 20px;
  background: url(${({ background }: ImageWrapperProps) => background});
  width: 7rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const StyledContactWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  `;
